import React from "react";
import { useLocation, useParams } from "react-router-dom";
import AddressForm from "../../components/seller/AddressFrom";

const AddressFormPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const addressFromState = location.state?.address;

  return (
    <AddressForm
      mode={id ? "edit" : "add"}
      initialData={addressFromState}
    />
  );
};

export default AddressFormPage;
